export default "__VITE_ASSET__CUnpgONj__"